import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../../../reducers";
import {ConfigApi} from "../../../../services/Api/types";

interface OwnProps {
    config: ConfigApi;
    skipPlaceDetails?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const Hero = (props: Props) => {
    const {config} = props;
    const {t} = useTranslation();
    let coverImgView = null;

    if (!config) return null;

    if (config.layout.cover_link) {
        coverImgView = (
            <img src={config.layout.cover_link.default} alt={t("modules.homepage.field.cover_image.title")}/>
        )
    } else {
        coverImgView = (
            <img src="/images/test/cover.jpg" alt={t("modules.homepage.field.cover_image.title")}/>
        )
    }

    const shouldRenderDetails = () => {
        if (props.skipPlaceDetails) {
            return (config.header || (config.tags && config.tags.length > 0)) && config.name;
        }
        return true;
    }

    return (
        <div className={"container-fluid"}>
            <div className={"cover-new"}>
                {coverImgView}
            </div>
            {
                shouldRenderDetails() && (
                    <div className={"cover-header"}>
                        <h1>
                            {config.name}
                        </h1>
                        {config.header && (
                            <p>
                                {config.header}
                            </p>
                        )}
                        {(config.tags && config.tags.length > 0) && (
                            <div className="badge-container d-flex overflow-auto hide-scrollbar">
                                {config.tags.map((tag: string) =>
                                    <span key={tag} className="badge me-2">{tag}</span>
                                )}
                            </div>
                        )}
                    </div>
                )
            }
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(Hero));